// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lZkwJjKMXRcxsL {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.DVk8j2DkxFqnKZ {
  position: relative;
  align-items: center;
  justify-content: center;
  margin-right: var(--ds-space-negative-050, -4px);
  background-color: unset;
}
.DVk8j2DkxFqnKZ:hover {
  background-color: unset;
}
.god0fVOmLMFYbi {
  margin: unset;
  border-radius: var(--ds-border-radius-circle, 50%);
  font-size: 12px;
  vertical-align: top;
}
.smQedIOI95963C {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ds-background-accent-gray-subtler, #dcdfe4);
}
.GgZ16m1TqbV_YP {
  transition: background 0.3s ease;
  cursor: pointer;
}
.RFz6SRe61Th_TU:hover,
.RFz6SRe61Th_TU:focus {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
}
`, ""]);
// Exports
export var facepile = `lZkwJjKMXRcxsL`;
export var avatar = `DVk8j2DkxFqnKZ`;
export var showMore = `god0fVOmLMFYbi`;
export var showMoreDisabled = `smQedIOI95963C`;
export var showMoreClickable = `GgZ16m1TqbV_YP`;
export var boardMenuShowMoreClickable = `RFz6SRe61Th_TU`;
export default ___CSS_LOADER_EXPORT___;
